module.exports = __webpack_public_path__ + "img/qr-box.310a1e40.png";